<template>
  <WizardWrap
    v-if="stage !== null && access"
    :texts="text"
    :stage="stage"
  />
</template>

<script>
import _ from "lodash";
import CurrencySupport from "@/help/currencySupport";
import WizardWrap from "@/components/wizard/WizardWrap.vue";
import { mapGetters } from "vuex";

export default {
  name: "RWAWizard",
  components: { WizardWrap },
  data() {
    return {
      currencySup: new CurrencySupport()
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile/profile",
      ethAddresses: "ethAddresses",
      tokensUtility: "tokensUtility"
    }),

    access() {
      return this.$route.name == "project card" || this.$route.name == "user";
    },

    tokenBalance() {
      const item = _.find(this.tokensUtility, el => el.mnemonicEng === process.env.VUE_APP_TOKEN_DEFAULT);
      return this.currencySup.getAmount(item.id);
    },

    stage() {
      if (!this.profile?.isConfirmed) {
        return 0;
      }
      if (this.profile?.kycStatus !== "completed") {
        return 1;
      }
      if (!this.tokenBalance) {
        return 2;
      }

      return null;
    },

    address() {
      return _.get(this.ethAddresses, "[0]", "");
    },

    text() {
      return [
        {
          label: {
            text: this.$t("emailWizard.title1")
          },
          button: {
            text: this.$t("emailWizard.titleBtn1"),
            link: "/user?resendEmail=true"
          },
          verification: false
        },
        {
          label: { text: "Thank you for registering! Complete your KYC verification to unlock full access and get started" },
          button: {
            text: "Start",
            link: "/kyc"
          },
          verification: false
        },
        {
          label: { text: "Fund your account to start investing." },
          button: {
            text: "Start",
            link: "/my-assets/card-buy-form"
          },
          verification: false
        }
      ];
    }
  }
};
</script>

<style scoped lang="scss"></style>